import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ShopScheduleModal.styles';
import { Modal } from '@/components/UI/Modal/Modal';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';
import { Button } from '@/components/UI/Button/Button';
import { CloseIcon } from '@/components/UI/Icons/Icons';
import useScreenSize from '@/hooks/useScreenSize';
import type { ScheduleDayItem } from '@/components/Shop/ShopScheduleModal/ShopScheduleModal.helpers';

export interface ShopScheduleModalProps {
  isOpen: boolean;
  onClose: () => void;
  scheduleDaysList: ScheduleDayItem[];
}

export const ShopScheduleModal: React.FC<ShopScheduleModalProps> = ({
  isOpen,
  onClose,
  scheduleDaysList,
}) => {
  const { t } = useTranslation();
  const { isLarge } = useScreenSize();

  if (isLarge) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} maxWidth={500} isScrollLocked>
        <S.Content>
          <S.TitleRow>
            <S.Title>{t('shop.schedule_title')}</S.Title>
            <Button
              appearance="transparent"
              hasPadding={false}
              onClick={onClose}
              style={{
                position: 'absolute',
                right: 0,
                top: 0,
              }}
              aria-label={t('common.hide')}
            >
              <CloseIcon width={20} height={20} />
            </Button>
          </S.TitleRow>
          {scheduleDaysList.map(({ dayName, hours }) => (
            <S.Row key={dayName}>
              <S.Day>{dayName}</S.Day>
              <S.Hours>{hours}</S.Hours>
            </S.Row>
          ))}
        </S.Content>
      </Modal>
    );
  }

  return (
    <BottomSheet
      isOpen={isOpen}
      close={onClose}
      title={t('shop.schedule_title')}
      isInPortal
      hasHeadBorder={false}
      isTitleCentered={false}
    >
      <S.Content>
        {scheduleDaysList.map(({ dayName, hours }) => (
          <S.Row key={dayName}>
            <S.Day>{dayName}</S.Day>
            <S.Hours>{hours}</S.Hours>
          </S.Row>
        ))}
      </S.Content>
    </BottomSheet>
  );
};
